export default "__VITE_ASSET__dDDppgPK__"